import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PrefillSlotsCompProps } from "./types";

// Prefill Slots Component
export function PrefillSlotsComp(t0) {
  const $ = _c(19);
  const {
    handleConfirm,
    dates,
    parsedTimes
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-lg font-semibold text-gray-800 mb-4">Existing Slots found</h2>;
    t2 = <p className="text-center text-gray-700 mb-6 text-sm leading-relaxed">You have already provided the following slots while requesting the visit on a nearby property that is within a radius of 10 km. Would you like us to automatically fill in these details for you?</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dates || $[3] !== parsedTimes) {
    let t4;
    if ($[5] !== parsedTimes) {
      t4 = el => <tr key={el} className="border-b border-gray-200 last:border-b-0"><td className="py-3 px-3 font-medium text-gray-800 text-sm whitespace-nowrap">{el}</td><td className="py-3 px-3 text-gray-600 text-sm">{parsedTimes[el].join(", ")}</td></tr>;
      $[5] = parsedTimes;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = dates.map(t4);
    $[2] = dates;
    $[3] = parsedTimes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="w-full mb-6 bg-gray-50 rounded-lg p-4 border border-gray-200 overflow-x-auto"><table className="w-full border-collapse"><tbody>{t3}</tbody></table></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleConfirm) {
    t5 = <button className="flex-1 cursor-pointer px-4 py-2 bg-primary text-white rounded text-sm font-medium hover:bg-primary/90 transition-colors" onClick={() => handleConfirm(true)}>Yes, Autofill</button>;
    $[9] = handleConfirm;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleConfirm) {
    t6 = <button className="flex-1 cursor-pointer px-4 py-2 text-primary-700 rounded text-sm font-medium hover:bg-primary/10 transition-colors" onClick={() => {
      handleConfirm(false);
    }}>Skip</button>;
    $[11] = handleConfirm;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="w-full gap-2 flex flex-row justify-around items-center">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <div className="w-full flex flex-col p-6 justify-around items-center">{t1}{t2}{t4}{t7}</div>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}